import { render, staticRenderFns } from "./fixed_asset_edit.vue?vue&type=template&id=7ff53ff5&scoped=true"
import script from "./fixed_asset_edit.vue?vue&type=script&lang=js"
export * from "./fixed_asset_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff53ff5",
  null
  
)

export default component.exports